//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["info"],
  data() {
    return {
      mobile_reg: /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/,
      codeText: "验证码",
      codeTimer: null,
      brandOpenId: "",
      bdOpenId: "",
      oaOpenId: ""
    };
  },
  created() {},
  mounted() {
    this.brandOpenId = this.$route.query.bdOpenId;
    this.bdOpenId = this.$route.query.bdOpenId;
    this.oaOpenId = this.$route.query.oaOpenId;
    console.log(this.brandOpenId, "参数");
  },
  methods: {
    getCheckCode() {
      var Mobile = this.info.Mobile;
      if (!Mobile) {
        this.$msg.fail("请输入手机号");
        return;
      }
      if (!this.mobile_reg.test(Mobile)) {
        this.$msg.fail("手机号码有误");
        return;
      }
      this.$msg.loading();
      var url =
        "/YslMisApi/Wechat/GetMobileCode?bdOpenId=" +
        this.bdOpenId +
        "&oaOpenId=" +
        this.oaOpenId;
      this.$http({
        url: url,
        method: "post",
        data: {
          mobile: Mobile,
          brandOpenId: this.brandOpenId,
          bdOpenId: this.bdOpenId,
          oaOpenId: this.oaOpenId
        }
      }).then(res => {
        this.$msg.hideLoading();
        console.log("验证码", res);
        if (res.data.state == 1) {
          this.$msg.toast("验证码已发送");
          this.codeText = 120;
          this.codeTimer = setInterval(() => {
            if (this.codeText > 1) {
              this.codeText--;
            } else {
              this.codeText = "验证码";
              clearInterval(this.codeTimer);
              this.codeTimer = null;
            }
          }, 1000);
          return;
        }

        this.$msg.alert(res.data.msg);
      });
    },
    startReg() {
      if (!this.info.Mobile) {
        this.$msg.fail("请输入手机号");
        return;
      }
      if (!this.info.code) {
        this.$msg.fail("请输入验证码");
        return;
      }
      this.$emit("startBind");
    }
  }
};
